
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/AuthContext";
import { BackButton } from "./BackButton";
import { ProfileAvatar } from "@/components/ui/profile-avatar";

interface HeaderProps {
  username: string;
  role: string;
  avatarUrl: string;
  showBackButton?: boolean;
  title?: string;
}

export const Header: React.FC<HeaderProps> = ({ 
  username, 
  role, 
  avatarUrl, 
  showBackButton = false,
  title
}) => {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const [showMenu, setShowMenu] = React.useState(false);

  const handleLogout = async () => {
    await signOut();
    navigate("/");
  };

  const handleProfileClick = () => {
    navigate("/profil");
    setShowMenu(false);
  };

  return (
    <div className="fixed top-0 left-0 right-0 bg-gray-800 text-white px-4 py-3 z-50">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          {showBackButton && <BackButton />}
          {title ? (
            <h1 className="text-lg font-bold">{title}</h1>
          ) : (
            <div>
              <p className="text-lg font-bold">Bonjour {username}</p>
              <p className="text-sm text-gray-300">Rôle: {role}</p>
            </div>
          )}
        </div>
        <div className="relative">
          <button 
            id="profile-button" 
            className="rounded-full overflow-hidden"
            onClick={() => setShowMenu(!showMenu)}
          >
            <ProfileAvatar 
              avatarUrl={null}
              role={role as "admin" | "ouvrier"}
              size="md"
            />
          </button>
          
          {showMenu && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
              <button 
                onClick={handleProfileClick}
                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Mon profil
              </button>
              <button 
                onClick={handleLogout}
                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Se déconnecter
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
